
// import InputText from "primevue/inputtext";
// import Button from "primevue/button";
// import { Form, Field, ErrorMessage } from "vee-validate";
import ProgressSpinner from "primevue/progressspinner";
import Message from "primevue/message";
import { RouterName } from "@/models/common";

import {
  computed,
  defineComponent,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  Ref,
} from "vue";

import { useI18n } from "vue-i18n";
import { IAlert } from "@/models/common";
import { messageType } from "@/models/message";

import { useStore } from "@/store";
import router from "@/router";
import $API from "@/services";
import { AuthMutationTypes } from "@/store/modules/auth/mutations";
import { AuthActionTypes } from "@/store/modules/auth/actions";

export default defineComponent({
  name: "Link By Komef",

  props: {
    id: String,
  },

  setup(props) {
    const store = useStore();

    const page = router.currentRoute.value.query.page || "";

    const { t, locale } = useI18n({ useScope: "global" });

    const isFetching = ref(true);
    const isFailedLink = ref(false);

    const message = ref(t("logging in"));

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    const state = reactive({
      roleName: "",
      hcode: "",
      dcode: "",
      page: "",
    });

    onBeforeMount(async () => {});
    onBeforeUnmount(async () => {});

    onMounted(async () => {
      console.log("onMounted: props=>", props);

      setTimeout(async () => {
        await loginByLinkId();
      }, 800);
    });

    const loginByLinkId = async () => {
      try {
        store.commit(AuthMutationTypes.SET_TOKEN, "");

        const linkId = props.id || "";

        isFetching.value = true;

        message.value = t("logging in");

        const loginResult = await $API.KomefAccountService.login(linkId);
        console.log("loginResult=>", loginResult);

        store.commit(AuthMutationTypes.SET_TOKEN, loginResult.accessToken);
        state.roleName = loginResult.roleName;
        state.hcode = loginResult.hcode;
        state.dcode = loginResult.dcode;
        state.page = loginResult.page;

        const accountInfo = await store.dispatch(AuthActionTypes.GET_ACCOUNT_INFO);
        console.log("accountInfo=>", accountInfo);

        setTimeout(() => {
          message.value = t("login successful");

          if (state.page && state.page.length > 0) {
            if (state.page === "appointment") {
              router.push({
                name: RouterName.ONLINE_CARE,
              });
            } else if (state.page === "referral") {
              router.push({
                name: RouterName.SECOND_OPINION,
              });
            }
          } else {
            router.push({
              name: RouterName.ONLINE_CARE_REQUEST_NEW,
              query: {
                hcode: state.hcode,
                dcode: state.dcode,
              },
            });
          }
        }, 2000);
      } catch (ex) {
        console.warn(ex, "<=ex");
        message.value = t("login failed");
        if (ex && (ex as any).Exception) {
          alert.value.content = (ex as any).Exception || t("login failed");
        } else {
          alert.value.content = t("login failed");
        }
        isFailedLink.value = true;
      } finally {
        setTimeout(() => {
          isFetching.value = false;
        }, 2000);
      }
    };

    // 방 상태 정보
    const linkId = computed(() => {
      return props.id || "";
    });

    const messageSeverity = computed(() => {
      if (isFailedLink.value) {
        return "error";
      }

      if (isFetching.value) {
        return "info";
      }

      return "success";
    });

    return {
      page,
      store,
      alert,
      t,
      locale,
      isFetching,
      isFailedLink,
      linkId,
      message,
      messageSeverity,
    };
  },

  components: { ProgressSpinner, Message },
});
